export default __webpack_public_path__ + "media/images/icons_fc/chart5-eb48955492cc9491106f8b3770952836.png";